<div class="info-page-wrapper">

    <!-- Page Header -->
    <div class="page-header">
        <h1>Get In Touch</h1>
        <p>We'd love to hear from you. Reach out to us anytime.</p>
    </div>

    <!-- Contact Cards -->
    <div class="contact-cards">

        <div class="contact-card">
            <div class="icon-circle">
                <i class="fa fa-phone"></i>
            </div>
            <h3>Call Us</h3>
            <p><a href="tel:9160006702">9160006702</a></p>
        </div>

        <div class="contact-card">
            <div class="icon-circle whatsapp">
                <i class="fa fa-whatsapp"></i>
            </div>
            <h3>WhatsApp</h3>
            <p><a href="https://wa.me/919154730496" target="_blank">+91 91547 30496</a></p>
        </div>

        <div class="contact-card">
            <div class="icon-circle">
                <i class="fa fa-envelope"></i>
            </div>
            <h3>Email Us</h3>
            <p><a href="mailto:info@goldbharat.com">info@goldbharat.com</a></p>
        </div>

        <div class="contact-card">
            <div class="icon-circle">
                <i class="fa fa-clock-o"></i>
            </div>
            <h3>Working Hours</h3>
            <p>Mon - Sat: 9:30 AM – 6:30 PM</p>
            <span class="note">2nd &amp; 4th Saturdays Holidays</span>
        </div>

    </div>

    <!-- Divider -->
    <div class="section-divider"></div>

    <!-- App Download Section -->
    <div class="app-section">
        <div class="app-text">
            <h2>Download Our App</h2>
            <p>Get the Gold Bharat app for a better experience on the go.</p>
        </div>
        <div class="app-badges">
            <a href="#" target="_blank" class="app-badge">
                <img src="../../assets/images/goldbahratgoogleplay.png.png" alt="Get it on Play Store">
            </a>
            <a href="#" target="_blank" class="app-badge">
                <img src="../../assets/images/Goldbaharatappstore.png.png" alt="Download on App Store">
            </a>
        </div>
    </div>

    <!-- Divider -->
    <div class="section-divider"></div>
    <!-- Associates Section -->
    <div class="associates-section">
        <h1>Our Associates</h1>
        <div class="associates-cards">
            <div class="associate-card">
                <a href="https://goldsikka.com/" target="_blank" rel="noopener noreferrer">
                    <img src="../../assets/images/goldsikka-logo-new.png" alt="Goldsikka">
                </a>
            </div>
            <div class="associate-card">
                <a href="https://goldatm.in/" target="_blank" rel="noopener noreferrer">
                    <img src="../../assets/images/logo-goldatm.png" alt="Gold ATM">
                </a>
            </div>

            <div class="associate-card">
                <a href="https://xyug.in/" target="_blank" rel="noopener noreferrer">
                    <img src="../../assets/images/xyug.logo.png" alt="X-YUG">
                </a>
            </div>

            <div class="associate-card">
                <a href="https://ophc.in/" target="_blank" rel="noopener noreferrer">
                    <img src="../../assets/images/ophc.logo.svg" alt="OPHC">
                </a>
            </div>

            <div class="associate-card">
                <a href="https://globalgoldcity.com/" target="_blank" rel="noopener noreferrer">
                    <img src="../../assets/images/global.logo.png" alt="GGC">
                </a>
            </div>
        </div>
    </div>
    <!-- Social Media Section -->
    <div class="social-section">
        <h2>Follow Us</h2>
        <p>Stay connected with us on social media</p>
        <div class="social-icons">
            <a href="#" target="_blank" aria-label="Facebook" class="social-icon fb">
                <i class="fa fa-facebook"></i>
            </a>
            <a href="#" target="_blank" aria-label="Instagram" class="social-icon insta">
                <i class="fa fa-instagram"></i>
            </a>
            <a href="#" target="_blank" aria-label="Twitter" class="social-icon twitter">
                <i class="fa fa-twitter"></i>
            </a>
            <a href="#" target="_blank" aria-label="LinkedIn" class="social-icon linkedin">
                <i class="fa fa-linkedin"></i>
            </a>
        </div>
    </div>

</div>